export const linesColorArray = [
    {
        borderColor: 'rgb(43, 30, 202)',
        backgroundColor: 'rgba(43, 30, 202, 0.5)',
    },
    {
        borderColor: 'rgb(246, 124, 16)',
        backgroundColor: 'rgba(246, 124, 16, 0.5)',
    },
    {
        borderColor: 'rgb(221, 26, 106)',
        backgroundColor: 'rgba(221, 26, 106, 0.5)',
    },
    {
        borderColor: 'rgb(251, 181, 0)',
        backgroundColor: 'rgba(251, 181, 0, 0.5)',
    },
    {
        borderColor: 'rgb(46, 194, 16)',
        backgroundColor: 'rgba(46, 194, 16, 0.5)',
    },
    {
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
    },
    {
        borderColor: 'rgb(121, 26, 106)',
        backgroundColor: 'rgba(121, 26, 106, 0.5)',
    },
    {
        borderColor: 'rgb(83, 40, 202)',
        backgroundColor: 'rgba(83, 40, 202, 0.5)',
    },
    {
        borderColor: 'rgb(151, 101, 0)',
        backgroundColor: 'rgba(151, 101, 0, 0.5)',
    },
    {
        borderColor: 'rgb(23, 222, 235)',
        backgroundColor: 'rgba(23, 222, 235, 0.5)',
    },
    {
        borderColor: 'rgb(241, 26, 156)',
        backgroundColor: 'rgba(241, 26, 156, 0.5)',
    },
    {borderColor: 'rgb(43, 30, 22)', backgroundColor: 'rgba(43, 30, 22, 0.5)'},
    {
        borderColor: 'rgb(251, 101, 120)',
        backgroundColor: 'rgba(251, 101, 120, 0.5)',
    },
    {
        borderColor: 'rgb(146, 124, 160)',
        backgroundColor: 'rgba(146, 124, 160, 0.5)',
    },
    {
        borderColor: 'rgb(86, 194, 42)',
        backgroundColor: 'rgba(86, 194, 42, 0.5)',
    },
    {
        borderColor: 'rgb(200, 50, 80)',
        backgroundColor: 'rgba(200, 50, 80, 0.5)',
    },
    {
        borderColor: 'rgb(30, 144, 255)',
        backgroundColor: 'rgba(30, 144, 255, 0.5)',
    },
    {
        borderColor: 'rgb(255, 105, 180)',
        backgroundColor: 'rgba(255, 105, 180, 0.5)',
    },
    {
        borderColor: 'rgb(60, 179, 113)',
        backgroundColor: 'rgba(60, 179, 113, 0.5)',
    },
    {
        borderColor: 'rgb(255, 165, 0)',
        backgroundColor: 'rgba(255, 165, 0, 0.5)',
    },
    {
        borderColor: 'rgb(106, 90, 205)',
        backgroundColor: 'rgba(106, 90, 205, 0.5)',
    },
    {
        borderColor: 'rgb(220, 20, 60)',
        backgroundColor: 'rgba(220, 20, 60, 0.5)',
    },
    {
        borderColor: 'rgb(0, 191, 255)',
        backgroundColor: 'rgba(0, 191, 255, 0.5)',
    },
    {borderColor: 'rgb(255, 69, 0)', backgroundColor: 'rgba(255, 69, 0, 0.5)'},
    {
        borderColor: 'rgb(50, 205, 50)',
        backgroundColor: 'rgba(50, 205, 50, 0.5)',
    },
    {
        borderColor: 'rgb(138, 43, 226)',
        backgroundColor: 'rgba(138, 43, 226, 0.5)',
    },
    {
        borderColor: 'rgb(255, 99, 71)',
        backgroundColor: 'rgba(255, 99, 71, 0.5)',
    },
    {
        borderColor: 'rgb(32, 178, 170)',
        backgroundColor: 'rgba(32, 178, 170, 0.5)',
    },
    {
        borderColor: 'rgb(255, 140, 0)',
        backgroundColor: 'rgba(255, 140, 0, 0.5)',
    },
    {
        borderColor: 'rgb(72, 61, 139)',
        backgroundColor: 'rgba(72, 61, 139, 0.5)',
    },
    {
        borderColor: 'rgb(255, 0, 255)',
        backgroundColor: 'rgba(255, 0, 255, 0.5)',
    },
    {
        borderColor: 'rgb(0, 128, 128)',
        backgroundColor: 'rgba(0, 128, 128, 0.5)',
    },
    {
        borderColor: 'rgb(255, 215, 0)',
        backgroundColor: 'rgba(255, 215, 0, 0.5)',
    },
    {borderColor: 'rgb(75, 0, 130)', backgroundColor: 'rgba(75, 0, 130, 0.5)'},
    {
        borderColor: 'rgb(255, 20, 147)',
        backgroundColor: 'rgba(255, 20, 147, 0.5)',
    },
    {borderColor: 'rgb(0, 100, 0)', backgroundColor: 'rgba(0, 100, 0, 0.5)'},
    {
        borderColor: 'rgb(255, 127, 80)',
        backgroundColor: 'rgba(255, 127, 80, 0.5)',
    },
    {
        borderColor: 'rgb(70, 130, 180)',
        backgroundColor: 'rgba(70, 130, 180, 0.5)',
    },
    {borderColor: 'rgb(255, 0, 0)', backgroundColor: 'rgba(255, 0, 0, 0.5)'},
    {borderColor: 'rgb(0, 0, 255)', backgroundColor: 'rgba(0, 0, 255, 0.5)'},
    {
        borderColor: 'rgb(255, 255, 0)',
        backgroundColor: 'rgba(255, 255, 0, 0.5)',
    },
    {borderColor: 'rgb(0, 255, 0)', backgroundColor: 'rgba(0, 255, 0, 0.5)'},
    {
        borderColor: 'rgb(255, 0, 255)',
        backgroundColor: 'rgba(255, 0, 255, 0.5)',
    },
    {
        borderColor: 'rgb(0, 255, 255)',
        backgroundColor: 'rgba(0, 255, 255, 0.5)',
    },
    {borderColor: 'rgb(128, 0, 0)', backgroundColor: 'rgba(128, 0, 0, 0.5)'},
    {borderColor: 'rgb(0, 128, 0)', backgroundColor: 'rgba(0, 128, 0, 0.5)'},
    {borderColor: 'rgb(0, 0, 128)', backgroundColor: 'rgba(0, 0, 128, 0.5)'},
    {
        borderColor: 'rgb(128, 128, 0)',
        backgroundColor: 'rgba(128, 128, 0, 0.5)',
    },
    {
        borderColor: 'rgb(128, 0, 128)',
        backgroundColor: 'rgba(128, 0, 128, 0.5)',
    },
    {
        borderColor: 'rgb(0, 128, 128)',
        backgroundColor: 'rgba(0, 128, 128, 0.5)',
    },
    {
        borderColor: 'rgb(192, 192, 192)',
        backgroundColor: 'rgba(192, 192, 192, 0.5)',
    },
];

export const barsColorArray = [
    '#1f77b4',
    '#ff7f0e',
    '#2ca02c',
    '#d62728',
    '#9467bd',
    '#8c564b',
    '#e377c2',
    '#bcbd22',
    '#17becf',
    '#FF1493',
    '#00BFFF',
    '#FFD700',
    '#ADFF2F',
    '#FF4500',
    '#9400D3',
    '#00FF7F',
    '#FF6347',
    '#7B68EE',
    '#40E0D0',
    '#7f7f7f',
];
